function log(k, v) {
  if (process.env.NODE_ENV === 'development') {
    console.log("[" + k + "]:", v)
  }
}

module.exports = {
  log
}
